// Module
var code = "<a href=\"javascript:;\" class=\"btn blue-dark subFormControl\"> <i class=\"fa fa-linkedin\" align=\"center\"></i> Linked In </a>";
// Exports
export default code;